import { Flex } from "@fluentui/react-northstar";
import React from "react";
import { RegularText } from "shared/components";
import { constants } from "shared/constants";
import pl from "shared/messages/pl";

export function getValuesOrDefaultColumnView(rows: (string | undefined)[]) {
    if (rows.length === 0) {
        return null;
    }

    return (
        <Flex column>
            {rows.map((r) => {
                return <RegularText key={r ?? constants.noValue} content={r ?? constants.noValue} />;
            })}
        </Flex>
    );
}

export function getValuesOrDefaultRowView(items: (string | undefined)[]) {
    if (items.length === 0) {
        return null;
    }

    var content : string[] = [];
    items.forEach((value, index) => {
        if (index > 0) {
            content.push(constants.inlineSeparator);
        }
        content.push(value ?? constants.noValue);
    });

    return (
        <RegularText content={content.join(" ")}/>
    );
}

export function getSingleValueOrDefault(value: string | undefined) {
    return <RegularText content={value ?? constants.noValue} />;
}

export function mapBoolValues(variable: boolean | undefined) {
    if (variable != null) {
        return variable ? pl.common.yes : pl.common.no;
    }
    return undefined;
}
